import { render, staticRenderFns } from "./Mass.vue?vue&type=template&id=2d72bc8b&"
import script from "./Mass.vue?vue&type=script&lang=js&"
export * from "./Mass.vue?vue&type=script&lang=js&"
import style0 from "./Mass.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QPage});
